const enum TeamEmailTarget {
  Users = 0,
  Team = 1
}
export default TeamEmailTarget;
